import { tv, type VariantProps } from "tailwind-variants";

export const userConsentVariant = tv({
  slots: {
    base: [],
    overlay: ["fixed inset-0 bg-black/75 z-20 data-[state=open]:animate-overlayShow"],
    content: [
      "z-21 fixed left-1/2 top-1/2",
      "max-h-[85vh] w-[90vw] max-w-lg p-8",
      "rounded-2xl bg-[var(--color-shades-1)] shadow-[var(--shades-10)]",
      "overflow-y-auto",
      "-translate-x-1/2 -translate-y-1/2 focus:outline-none data-[state=open]:animate-contentShow",
    ],
    title: ["mb-2"],
    description: [
      "text-text-neutral-default [&>a]:text-text-neutral-default [&>a]:underline",
    ],
    closeButton: [
      "absolute right-2.5 top-2.5",
      "inline-flex items-center justify-center",
      "size-6",
      "rounded-full text-violet11 bg-gray3 appearance-none",
      "hover:bg-violet4 focus:shadow-[0_0_0_2px] focus:shadow-violet7 focus:outline-none",
    ],
    fieldset: ["flex flex-col gap-1 mb-4 w-full"],
    label: ["w-full text-text-neutral-default"],
    input: [
      "w-full h-10 px-2.5",
      "rounded-lg border border-border-neutral-strong text-3 leading-none outline-none",
      "ring-inset focus:ring-1 focus:ring-border-static-black",
    ],
    checkbox: [
      "flex shrink-0 items-center justify-center p-1",
      "size-5 rounded bg-transparent",
      "border border-border-neutral-strong",
      "appearance-none outline-none",
      "hover:bg-background-neutral-inverse/10",
      "data-[state=checked]:bg-background-neutral-inverse",
    ],
    checkboxIndicator: [
      "text-text-neutral-default data-[state=checked]:text-text-neutral-inverse",
    ],
    checkboxIndicatorIcon: ["size-3"],
    actions: ["mt-6 flex w-full"],
    loading: ["animate-spin", "size-4", "text-text-neutral-inverse"],
  },
  variants: {},
  defaultVariants: {},
});

export type UserConsentVariantProps = VariantProps<typeof userConsentVariant>;
export type UserConsentReturnVariantProps = ReturnType<typeof userConsentVariant>;
